var exports = {
  "k": "x8b4e8595--e280cd--container",
  "X": "x8b4e8595--e280cd--scroller",
};

module.exports = exports;
